import "../index.css";
import { useTranslation } from "react-i18next";
import {
  Card,
  CardContent,
  IconButton,
  LabelValue,
  Row,
  Tooltip,
  Typography,
} from "@/ui-kit";
import { AddressUtils } from "@/utils/address";
import { NotProvided } from "@/components/NotProvided";
import { PencilIcon } from "lucide-react";
import type { IAddress } from "@/types/address";

type IProps = {
  address: IAddress;
  onEdit?: () => void;
};

export const AddressDetailsCard = ({ address, onEdit }: IProps) => {
  const { t } = useTranslation();
  const labelWidth = "128px";

  return (
    <Card className="profile-card" variant="layer1">
      <CardContent>
        <Row gap={24} alignmentVertical="top">
          <div className="profile-card__details">
            <Row gap={12}>
              <Typography
                as="h3"
                weight="bold"
                variant="h3"
                color="text-primary"
                text={t("label.address")}
              />

              {onEdit && (
                <div className="profile-card__actions">
                  <Tooltip content={t("action.edit")} placement="bottom-end">
                    <IconButton
                      size="sm"
                      variant="ghost"
                      color="layer2"
                      content={<PencilIcon />}
                      onClick={onEdit}
                      aria-label={t("action.edit")}
                    />
                  </Tooltip>
                </div>
              )}
            </Row>

            <div className="profile-card__section">
              <LabelValue
                label={t("label.address")}
                value={
                  address.name ? (
                    AddressUtils.format(address)
                  ) : (
                    <Typography variant="headline" text={<NotProvided />} />
                  )
                }
                labelWidth={labelWidth}
                canCopy={!!address.name}
              />
            </div>
          </div>
        </Row>
      </CardContent>
    </Card>
  );
};
